import React from 'react';

// wrapping <div> is needed for the video not the break in cases where it will be moved around in the carousel
// otherwise `Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node` error will be thrown
export const Video: React.FC<{
  playerId: string;
  publicId: string;
  classNamePlayerId: string;
  altText: string | undefined;
}> = ({ playerId, publicId, classNamePlayerId, altText }) => (
  <div>
    <video
      id={playerId}
      data-cld-public-id={publicId}
      controls
      className={`cld-video-player vista-video-player ${classNamePlayerId}`}
      aria-label={altText}
    />
  </div>
);
